import WarehouseCell from './WarehouseCell'

export default WarehouseCell
